import { JobType } from '@api*';
import { faHouseLaptop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, Group } from '@mantine/core';

type ConfirmCheckboxPropsType = {
  jobType: JobType | null;
  isChecked: boolean;
  onCheckboxChange: (jobId: string, isChecked: boolean) => void;
};

export const ConfirmCheckbox: React.FC<ConfirmCheckboxPropsType> = ({
  jobType,
  isChecked,
  onCheckboxChange,
}) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!jobType) return;
    onCheckboxChange(jobType.id, event.currentTarget.checked);
  };

  const showRemoteIcon = jobType?.isRemote;

  return (
    <Group gap="xs">
      <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
      {showRemoteIcon && (
        <FontAwesomeIcon
          icon={faHouseLaptop}
          color="var(--mantine-color-gray-8)"
        />
      )}
    </Group>
  );
};
